<div class="card-container" style="padding: 5px 5px 0px 5px; max-width: 100%;">
  <mat-card appearance="outlined">
    <mat-card-header style="padding: 5px 0px 0px 15px;">
      <mat-card-title style="font-size: large">Port Disbursement Account Form</mat-card-title>
    </mat-card-header>
    <mat-card-footer class="example-card-footer">
      <table style="width: 100%; padding: 5px 13px 5px 13px;">
        <tr>
          <td class="subtitle">
            {{leftLongText}}
          </td>
          <td class="subtitle" align="end">
            {{rightLongText}}
          </td>
        </tr>
      </table>
    </mat-card-footer>
  </mat-card>
</div>

<div class="page-loader"  *ngIf="isLoading$ | async">
  <mat-spinner diameter="45"></mat-spinner>
</div>
<div class="container">
  <router-outlet></router-outlet>
</div>